module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memeber-wrapper"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "text-align": "center",
      "font-weight": "bold",
      "padding": "20px 0"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.userName) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-wrapper"
  }, [_c('div', {
    staticClass: "round header"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px",
      "font-size": "16px",
      "color": "#5c94be"
    }
  }, [_vm._v("\n      联盟商家:" + _vm._s(_vm.sn) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "inner_wrapper"
  }, [_c('div', {
    staticClass: "menu-part manage"
  }, [_c('ul', [_c('li', {
    class: _vm.active == 1 ? 'active' : '',
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(1)
      }
    }
  }, [_vm._v("\n            我的资料\n          ")]), _vm._v(" "), _c('li', {
    class: _vm.active == 2 ? 'active' : '',
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(2)
      }
    }
  }, [_vm._v("\n            补充我的资料\n          ")]), _vm._v(" "), _c('li', {
    class: _vm.active == 3 ? 'active' : '',
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(3)
      }
    }
  }, [_vm._v("\n            商品图管理\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/leagueAgreement',
      },
      "target": "_blank"
    }
  }, [_vm._v("\n              开心云商规则\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "round bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content_wrapper"
  }, [_c('div', {
    staticClass: "content-box header"
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "content-box bottom"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e273a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-data/index.vue
// module id = 1586
// module chunks = 1